<ion-header class="ion-no-border">

	<ion-toolbar>
        <ion-buttons slot="start">
			<ion-button (click)="close()">
				<fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
			</ion-button>
		</ion-buttons>
        <ion-title>Printer paper sizes</ion-title>
        <ion-buttons slot="end">
			<ion-button (click)="update()">
				<fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
			</ion-button>
		</ion-buttons>
    </ion-toolbar>

</ion-header>

<ion-content>

    <ion-list>
        <ion-item lines="full">
            <ion-label>A4</ion-label>
            <ion-checkbox slot="end" [checked]="printer_paper_sizes.includes('a4')" (ionChange)="onPaperSizeChange($event, 'a4')"></ion-checkbox>
        </ion-item>
        <ion-item lines="full">
            <ion-label>Thermal</ion-label>
            <ion-checkbox slot="end" [checked]="printer_paper_sizes.includes('thermal')" (ionChange)="onPaperSizeChange($event, 'thermal')"></ion-checkbox>
        </ion-item>
    </ion-list>

</ion-content>